import { render, staticRenderFns } from "./EmailPreferencesView.vue?vue&type=template&id=1afdb8b8&scoped=true&"
import script from "./EmailPreferencesView.vue?vue&type=script&lang=js&"
export * from "./EmailPreferencesView.vue?vue&type=script&lang=js&"
import style0 from "./EmailPreferencesView.vue?vue&type=style&index=0&id=1afdb8b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1afdb8b8",
  null
  
)

export default component.exports